import {
    ANALYTICS_SUMMARY_REQUEST,
    ANALYTICS_SUMMARY_SUCCESS,
    ANALYTICS_SUMMARY_FAIL,
    TOP_PRODUCTS_REQUEST,
    TOP_PRODUCTS_SUCCESS,
    TOP_PRODUCTS_FAIL,
    TOP_CUSTOMERS_REQUEST,
    TOP_CUSTOMERS_SUCCESS,
    TOP_CUSTOMERS_FAIL,
    SALES_DATA_REQUEST,
    SALES_DATA_SUCCESS,
    SALES_DATA_FAIL,
    SET_ANALYTICS_DATE_RANGE,
    SET_ANALYTICS_FINANCIAL_YEAR,
    ANALYTICS_CLEAR_ERRORS
} from '../constants/analyticsConstants';

// FY defaults per year
const FY_DATES = {
    '2324': { start: '2023-04-01', end: '2024-03-31' },
    '2425': { start: '2024-04-01', end: '2025-03-31' },
    '2526': { start: '2025-04-01', end: '2026-03-31' },
    '2627': { start: '2026-04-01', end: '2027-03-31' },
};

const DEFAULT_FY = '2627';

const initialState = {
    summary: null,
    topProducts: [],
    topCustomers: [],
    salesData: [],
    loading: false,
    error: null,
    financialYear: DEFAULT_FY,
    startDate: FY_DATES[DEFAULT_FY].start,
    endDate: FY_DATES[DEFAULT_FY].end,
    // Cache keys (include financial year so switching year busts the cache)
    summaryRange: null,
    topProductsRange: null,
    topCustomersRange: null,
    salesDataRange: null,
};

export const analyticsReducer = (state = initialState, action) => {
    switch (action.type) {

        case SET_ANALYTICS_FINANCIAL_YEAR: {
            const fy = action.payload;
            const dates = FY_DATES[fy] || FY_DATES[DEFAULT_FY];
            return {
                ...state,
                financialYear: fy,
                startDate: dates.start,
                endDate: dates.end,
                // Bust all caches so data is re-fetched for new year
                summaryRange: null,
                topProductsRange: null,
                topCustomersRange: null,
                salesDataRange: null,
            };
        }

        case SET_ANALYTICS_DATE_RANGE:
            return {
                ...state,
                startDate: action.payload.startDate,
                endDate: action.payload.endDate
            };

        case ANALYTICS_SUMMARY_REQUEST:
        case TOP_PRODUCTS_REQUEST:
        case TOP_CUSTOMERS_REQUEST:
        case SALES_DATA_REQUEST:
            return { ...state, loading: true, error: null };

        case ANALYTICS_SUMMARY_SUCCESS:
            return {
                ...state,
                loading: false,
                summary: action.payload.data,
                summaryRange: action.payload.range
            };

        case TOP_PRODUCTS_SUCCESS:
            return {
                ...state,
                loading: false,
                topProducts: action.payload.data,
                topProductsRange: action.payload.range
            };

        case TOP_CUSTOMERS_SUCCESS:
            return {
                ...state,
                loading: false,
                topCustomers: action.payload.data,
                topCustomersRange: action.payload.range
            };

        case SALES_DATA_SUCCESS:
            return {
                ...state,
                loading: false,
                salesData: action.payload.data,
                salesDataRange: action.payload.range
            };

        case ANALYTICS_SUMMARY_FAIL:
        case TOP_PRODUCTS_FAIL:
        case TOP_CUSTOMERS_FAIL:
        case SALES_DATA_FAIL:
            return { ...state, loading: false, error: action.payload };

        case ANALYTICS_CLEAR_ERRORS:
            return { ...state, error: null };

        default:
            return state;
    }
};
